import React, { FC, useEffect } from 'react'

import { useDispatch } from 'react-redux'
import { useParams } from 'react-router'
import styled from 'styled-components'

import { fetchBreadCrumbsProfileAction } from 'actions/seo/breadCrumbsAction'
import {
  BreadCrumbs,
  Place,
} from 'components/block/Seo/BreadCrumbs/BreadCrumbs'
import { ProfileRouteParams } from 'components/paths'
import { useReducersInsert } from 'hooks/useReducersInsert'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'
import { breadCrumbsReducer } from 'reducers/seo/breadCrumbs'

export const ForeignProfileBreadCrumbs: FC = () => {
  useReducersInsert({ breadCrumbs: breadCrumbsReducer })

  const dispatch = useDispatch()
  const { profileLinks } = useShallowEqualSelector(
    ({ breadCrumbs: { profileLinks } }) => ({
      profileLinks,
    })
  )
  const { userId } = useParams<ProfileRouteParams>()

  useEffect(() => {
    dispatch(fetchBreadCrumbsProfileAction(Number(userId)))
  }, [userId, dispatch])

  if (profileLinks.length > 0) {
    return (
      <Margin>
        <BreadCrumbs links={profileLinks} place={Place.profile} />
      </Margin>
    )
  }

  return null
}

export const Margin = styled.div`
  margin-top: 10px;
`
